<!--
 * @Description: 无限滚动加载组件，比较粗糙，后期可优化
 * @Author: kayvor
 * @Date: 2020-03-31 18:00:09
 * @LastEditTime: 2020-06-03 12:07:33
 * @LastEditors: kayvor
 -->

<template>
  <div class="infiniteLoadData-component" ref="infiniteLoadData">
        <div class="infinite-list">
            <slot name="infinite"></slot>
            <slot name="loading">
                <div class="loading" v-if="showLoading">
                    <van-loading type="spinner" size="24" color="#c8c9cc" />
                </div>
            </slot>
            <slot name="noData">
                <div class="noData" v-if="!showLoading"><i></i><span>{{length ? endTip : '暂无数据'}}</span><i></i></div>
            </slot>
        </div>
  </div>
</template>

<script >
import BetterScroll from 'better-scroll'
export default {
    name: 'infiniteLoadData',
    props: {
        clientHeight: {
            type: Number,
            default: 0
        },
        /**
         * 是否显示loading，默认显示
        */
        showLoading: {
            type: Boolean,
            default: true
        },
        /**
         * 数据的长度
        */
        length: {
            type: Number,
            default: 0
        },
        /**
         * 数据
         */
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        /**
         * 是否有点击事件
         */
        isClick: {
            type: Boolean,
            default: true
        },
        /**
         * 设置滚动速度
         */
        probeType: {
            type: Number,
            default: 1
        },
        /**
         * 上拉加载更多，传入非false值为开启上拉加载，false为不开启
         */
        pullup: {
            type: Boolean,
            default: false
        },
        /**
         * 是否监听scroll事件，如果为true，需在父组件中加入对应监听的方法名
         */
        listenScroll: {
            type: Boolean,
            default: false
        },
        /**
         * 数据刷新延迟时间
         */
        refreshDelay: {
            type: Number,
            default: 20
        },
        /**
         * 设置当运行 momentum 动画时，超过边缘后的回弹整个动画时间
         */
        swipeBounceTime: {
            type: Number,
            default: 800
        },
        /**
         * 在屏幕上快速滑动的时间小于 momentumLimitTime，才能开启 momentum 动画
         */
        momentumLimitTime: {
            type: Number,
            default: 200
        },
        /**
         * 设置回弹动画的动画时长
         */
        bounceTime: {
            type: Number,
            default: 300
        },
        /**
         * 纵轴方向初始化位置
         */
        startY: {
            type: Number,
            default: 0
        },
        /**
         * bounce
         */
        bounce: {
            // eslint-disable-next-line vue/require-prop-type-constructor
            type: Boolean | Object,
            default: false
        },
        endTip: {
            type: String,
            default: '到底了'
        }
    },
    data () {
        return {
            client: {
                headerHeight: 0,
                height: 0,

            }
        }
    },
    watch: {
        clientHeight (newValue) {
            let height = this.client.height - this.client.headerHeight - 1
            if (newValue > 0) {
                height = height - newValue
            }
            this.$refs.infiniteLoadData.setAttribute('style', `height: ${height}px`)
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
        Object.assign(this.client, {
            headerHeight: document.querySelector('.componentHeader').clientHeight || 0,
            height: document.documentElement.clientHeight || document.body.clientHeight
        })
        let height = this.client.height - this.client.headerHeight - 1
        this.$refs.infiniteLoadData.setAttribute('style', `height: ${height}px`)
        this.$nextTick(() => {
            this.initScroll()
        })
    },
    methods: {
        /**
         * 初始化滚动
         */
        initScroll () {
            if (!this.$refs.infiniteLoadData) return
            // 初始化better-scroll
            this.BSScroll = new BetterScroll(this.$refs.infiniteLoadData, {
                probeType: this.probeType,
                click: this.isClick,
                swipeBounceTime: this.swipeBounceTime,
                bounceTime: this.bounceTime,
                momentumLimitTime: this.momentumLimitTime,
                scrollY: true,
                scrollX: true,
                startY: this.startY,
                pullUpLoad: this.pullup,
            })
            // 通过这个方法获取better-scroll初始化完成，进行做对应的操作
            this.$emit('init', this.BSScroll)
            // if (this.listenScroll) {
            //     let $this = this
            //     this.BSScroll.on('scroll', pos => {
            //         // 在父组件通过scroll方法获取坐标
            //         $this.$emit('scroll', pos)
            //     })
            // }
            // if (this.pullup) {
            //     this.BSScroll.on('pullingUp', () => {
            //         this.$emit('scrollToEnd', this.BSScroll)
            //     })
            // }
            if (this.pullup) {
                this.BSScroll.on('scrollEnd', () => {
                    // 滚动到底部
                    if (this.BSScroll.y <= (this.BSScroll.maxScrollY + 50)) {
                        this.$emit('scrollToEnd', this.BSScroll)
                    }
                })
            }
        },
        /**
         * 启动无线滚动加载方法
         */
        enable () {
            this.BSScroll && this.BSScroll.enable()
        },
        /**
         * 停止滚动加载数据
         */
        disable () {
            this.BSScroll && this.BSScroll.disable()
        },
        /**
         * 刷新滚动条，重新计算高度
         */
        refresh () {
            this.BSScroll && this.BSScroll.refresh()
        },
        /**
         * 滚动到指定位置
         */
        // scrollTo () {
        //     this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
        // },
        // /**
        //  * 滚动到指定的目标元素
        //  */
        // scrollToElement () {
        //     this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
        // }
    }
}
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables";

.infiniteLoadData-component
    position relative
    width 100%
    overflow hidden
    // background-color $bgGreyColor
    .loading
            padding 38px 0
            text-align center
        .noData
            padding 38px 0
            height 23px
            display flex
            justify-content center
            align-items center
            color $fcGreyish
            font-size $fontSmall
            text-align center
            span
                padding 0 30px
            i
                position relative
                top 0
                display inline-block
                width 5px
                height 5px
                background-color #c5c5c5
                border-radius 50%
                &:first-child
                    &:before
                        content ''
                        position absolute
                        // 为了让px不转成rem
                        top 1PX
                        right 0
                        width 68px
                        height 1PX
                        background-color #c5c5c5
                &:last-child
                    &:after
                        content ''
                        position absolute
                        // 为了让px不转成rem
                        top 1PX
                        left 0
                        width 68px
                        height 1PX
                        background-color #c5c5c5
</style>
